export { default as InformationIcon } from '@assets/icons/publisher/information-icon.svg';
export { default as SplitBranchIcon } from '@assets/icons/publisher/split-branch-icon.svg';
export { default as QuestionMarkIcon } from '@assets/icons/publisher/question-mark-icon.svg';
export { default as PublisherIcon } from '@assets/icons/publisher/publisher-icon.svg';
